import React from 'react';
import Section from '@latitude/section';
import './_image_banner.scss';

const ImageBanner = ({ desktopImage, mobileImage, imageAltText }) => {
  return (
    <div className="image-banner">
      <Section className="image-banner__section">
        {/* Desktop Image */}
        {desktopImage && (
          <img
            src={desktopImage}
            alt={imageAltText}
            className="image-banner__image image-banner__image--desktop"
          />
        )}

        {/* Mobile Image */}
        {mobileImage && (
          <img
            src={mobileImage}
            alt={imageAltText}
            className="image-banner__image image-banner__image--mobile"
          />
        )}
      </Section>
    </div>
  );
};

export default ImageBanner;
